var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-box"},[_c('div',{staticClass:"summary-box-title"},[_vm._t("default"),_c('span',[_vm._v("\n            "+_vm._s(_vm.$t(_vm.titleString))+"\n        ")])],2),_c('ChartDoughnut',{staticClass:"chart",attrs:{"chartData":_vm.chartData,"width":_vm.size,"height":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }